var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666855 8.52196C0.291365 8.08117 0.321185 7.42493 0.735105 7.02001C1.19911 6.56609 1.95301 6.60969 2.36159 7.11407L5.33333 10.7826L13.6158 2.75963C14.0523 2.33683 14.7461 2.33854 15.1805 2.76348C15.6301 3.20339 15.6301 3.92704 15.1805 4.36695L6.09915 13.2508C5.685 13.656 5.01431 13.6255 4.63862 13.1845L0.666855 8.52196Z",
    fill: "#96B000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkGreen);
export default __webpack_public_path__ + "static/media/checkmark-green.5cd6950a1fb1ed0b5356a4974e8c739f.svg";
export { ForwardRef as ReactComponent };